import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash-message"
// Shows the flash, then auto-hides it ONCE after 5s. (Was setInterval, which
// re-fired every 5s forever and leaked the timer.)
export default class extends Controller {
  connect() {
    if (this.element.innerHTML.trim() === "") return

    this.element.classList.remove("d-none")
    this.timeout = setTimeout(() => this.dismiss(), 5000)
  }

  // Manual × dismiss (or the 5s auto-hide). Clears the stack.
  dismiss() {
    if (this.timeout) clearTimeout(this.timeout)
    this.element.innerHTML = ""
    this.element.classList.add("d-none")
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }
}
